var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"transition duration-150 ease-in-out flex justify-center items-center absolute -bottom-7 right-2 w-14 h-14 rounded-full shadow-sm",class:[
    _vm.disabled ? 'bg-purple-200 cursor-not-allowed' : 'transform active:translate-y-0.5 bg-purple-400 cursor-pointer',
  ]},[_c('Icon',{class:[_vm.loading ? 'animate-spin' : ''],attrs:{"name":_vm.loading ? 'mdi-loading' : 'mdi-reload',"color":"white","size":"3xl"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }